// @flow

import TeamTooltip from './TeamTooltip'

export default TeamTooltip

